require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effectif-des-tudiants-2-0-4-0.json") })
        }
      }, "path---effectif-des-tudiants-2-0-4-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effectif-des-tudiants-2-0-4-0!./.cache/json/effectif-des-tudiants-2-0-4-0.json
// module id = 404
// module chunks = 231608221292675